/**
 * Journey Chip Helper Functions
 * Centralized functions for determining chip labels and colors based on time
 */

/**
 * Get chip label based on time
 * @param {string|object} time - Time value (MORNING/EVENING string or time object with hour)
 * @returns {string} Chip label
 */
export function getChipLabel(time) {
  // Handle string format (MORNING/EVENING)
  if (typeof time === 'string') {
    switch (time) {
      case 'MORNING':
        return 'Advice'
      case 'EVENING':
        return 'Celebrate'
      default:
        return 'Advice'
    }
  }

  // Handle object format with hour property
  if (time && typeof time === 'object' && time.hour !== undefined) {
    const hour = time.hour
    if (hour < 12) {
      return 'Advice'
    } else {
      return 'Celebrate'
    }
  }

  // Handle HH:mm:ss string format
  if (typeof time === 'string' && time.includes(':')) {
    const hour = parseInt(time.split(':')[0], 10)
    if (hour < 12) {
      return 'Advice'
    } else {
      return 'Celebrate'
    }
  }

  // Default fallback
  return 'Advice'
}

/**
 * Get chip color based on time
 * @param {string|object} time - Time value (MORNING/EVENING string or time object with hour)
 * @returns {string} Chip color
 */
export function getChipColor(time) {
  // Handle string format (MORNING/EVENING)
  if (typeof time === 'string') {
    switch (time) {
      case 'MORNING':
        return 'green'
      case 'EVENING':
        return 'blue'
      default:
        return 'green'
    }
  }

  // Handle object format with hour property
  if (time && typeof time === 'object' && time.hour !== undefined) {
    const hour = time.hour
    if (hour < 12) {
      return 'green'
    } else {
      return 'blue'
    }
  }

  // Handle HH:mm:ss string format
  if (typeof time === 'string' && time.includes(':')) {
    const hour = parseInt(time.split(':')[0], 10)
    if (hour < 12) {
      return 'green'
    } else {
      return 'blue'
    }
  }

  // Default fallback
  return 'green'
}

/**
 * Get time-based chip label for timed messages
 * @param {string|object} time - Time value (HH:mm:ss string or time object with hour)
 * @returns {string} Chip label
 */
export function getTimeChipLabel(time) {
  let hour

  if (typeof time === 'string') {
    // Parse HH:mm:ss format
    hour = parseInt(time.split(':')[0], 10)
  } else if (time && typeof time === 'object' && time.hour !== undefined) {
    hour = time.hour
  } else {
    hour = 0
  }

  if (hour < 12) {
    return 'Message'
  } else if (hour < 17) {
    return 'Reminder'
  } else {
    return 'Check-in'
  }
}

/**
 * Get time-based chip color for timed messages
 * @param {string|object} time - Time value (HH:mm:ss string or time object with hour)
 * @returns {string} Chip color
 */
export function getTimeChipColor(time) {
  let hour

  if (typeof time === 'string') {
    // Parse HH:mm:ss format
    hour = parseInt(time.split(':')[0], 10)
  } else if (time && typeof time === 'object' && time.hour !== undefined) {
    hour = time.hour
  } else {
    hour = 0
  }

  if (hour < 12) {
    return 'green'
  } else if (hour < 17) {
    return 'blue'
  } else {
    return 'green'
  }
}

/**
 * Get active tab based on time
 * @param {string|object} time - Time value (HH:mm:ss string or time object with hour)
 * @returns {string} Active tab (AM/PM)
 */
export function getTimeActiveTab(time) {
  let hour

  if (typeof time === 'string') {
    // Parse HH:mm:ss format
    hour = parseInt(time.split(':')[0], 10)
  } else if (time && typeof time === 'object' && time.hour !== undefined) {
    hour = time.hour
  } else {
    hour = 0
  }

  return hour < 12 ? 'AM' : 'PM'
}
